import config from '@/config/ConfigProvider';
const curriculumUrl = (url) => `${config.value('curriculumUrl')}/${url}`;

export { curriculumUrl };
